import React from 'react';

interface ResizeHandleProps {
    onMouseDown: (e: React.MouseEvent) => void;
    isResizing: boolean;
}

const ResizeHandle: React.FC<ResizeHandleProps> = ({ onMouseDown, isResizing }) => {
    return (
        <div
            className={`
        absolute left-0 top-0 w-1 h-full cursor-col-resize 
        group hover:bg-blue-400 hover:w-1.5
        ${isResizing ? 'bg-blue-500 w-1.5' : 'bg-gray-300'}
        transition-all duration-200
      `}
            onMouseDown={onMouseDown}
        >
            <div className="absolute left-0 top-1/2 -translate-y-1/2 w-3 h-12 -ml-1 opacity-0 group-hover:opacity-100 flex items-center justify-center">
                <div className="w-1 h-8 rounded-full bg-blue-400"></div>
            </div>
        </div>
    );
};

export default ResizeHandle;